import api from "@/lib/axios";

const dashboardService = {

  getDashboardOverview: async (params = {}) => {
    try {
      const response = await api.get("/dashboard", { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getDashboard: async (companyId, campaignId = [], vacancyId = [], stageId = [], rejectionStageId = []) => {

    try {
      const params = {};
      
      if (campaignId && campaignId.length > 0) params.campaign_id = campaignId;
      if (vacancyId && vacancyId.length > 0) params.vacancy_id = vacancyId;
      if (stageId && stageId.length > 0) params.stage_id = stageId;
      if (rejectionStageId && rejectionStageId.length > 0) params.rejected_at_id = rejectionStageId;

      const response = await api.get(`/company/${companyId}/dashboard`, { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default dashboardService;